<template>
    <!-- 销售合同月报 -->
    <div class="salesContractMonthBox">
        <div class="month-data-analysis" ref="inBoxHeight">
            <div class="top-echarts-two">
                <div class="echarts-left echarts-total">
                    <div class="title-box">
                        <h1>业务员销售合同数量统计</h1>
                        <span @click="lookMore(5)">查看完整数据</span>
                    </div>
                    <div style="width 100%;height:270px;flex 4" id="contractNumber"></div>
                </div>
                <div class="echarts-right echarts-total">
                    <div class="title-box">
                        <h1>预计销售方量</h1>
                        <span @click="lookMore(6)">查看完整数据</span>
                    </div>
                    <div style="width 100%;height:270px;flex 4" id="contractEstimate"></div>
                </div>
            </div>
            <exportDom :dom-id="'#salesTable'" :excel-name="'按业务员月报'"></exportDom>
            <div
                class="table-list"
                style="margin-top:10px;"
            >
                <el-table
                    ref="salesTable"
                    id="salesTable"
                    :data="tabListDataTwoName"
                    style="width: 100%"
                    show-summary
                    :summary-method="getSummariesTwo"
                >
                    <el-table-column
                        prop="name"
                        label="业务员"
                        fixed
                        width="150"
                    >
                    </el-table-column>
                    <el-table-column
                        v-for="(date, index) in tabListDataTwoDate"
                        :key="index"
                        :label="date"
                    >
                        <el-table-column
                            label="合同数量(个)"
                            :prop="date"
                            min-width="150"
                        >
                            <template slot-scope="scope">
                                <span v-for="(key, idx) in scope.row.list" :key="idx">
                                    <template v-if="key.date === date">
                                        {{ key.htsl }}
                                    </template>
                                </span>
                            </template>
                        </el-table-column>
                        <el-table-column
                            label="预计销售方量(方)"
                            :prop="date"
                            min-width="150"
                        >
                            <template slot-scope="scope">
                                <span v-for="(key, idx) in scope.row.list" :key="idx">
                                    <template v-if="key.date === date">
                                        {{ key.yjxsfl }}
                                    </template>
                                </span>
                            </template>
                        </el-table-column>
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <alertEcharts v-if="showContract" :alert-status="alertStatus" @closeChildAlert="closeChildFn"></alertEcharts>
    </div>
</template>

<script>
// import addBgImages from '../../utils';
import exportDom from './../export';
import alertEcharts from './components/index';
export default {
    data() {
        return {
            echartsColor: ['#EA8343', '#3E79C4', '#E6E429', '#FA9E94'],

            tabListDataTwo: [],
            tabListDataTwoName: [],
            tabListDataTwoList: [],
            tabListDataTwoDate: [],
            tabListEchartsHtTwo: [],

            showContract: false,
            htslSlotArr: [],
            yjflSlotArr: [],
        };
    },
    components: {
        alertEcharts,
        exportDom,
    },
    mounted() {
        this.bySalesman();
    },
    methods: {
        // 合计方法
        getSummariesTwo(param) {
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '合计';
                    return;
                }
                // 获取与当前行时间相同的数据
                const arr = this.tabListDataTwoList.filter(item => {
                    return column.property === item.date;
                });
                // 对应时间合同数量(个)和预计销售方量(方)的数值数组 // 对应每一列的数据数组
                const values = arr.map(item => {
                    if (column.label === '合同数量(个)') {return item.htsl;}
                    if (column.label === '预计销售方量(方)') {return item.yjxsfl;}
                });
                // const values = data.map(item => Number(item[column.property]));
                if (!values.every(value => isNaN(value))) {
                    sums[index] = values.reduce((prev, curr) => {
                        const value = Number(curr);
                        if (!isNaN(value)) {
                            return Math.round(prev + curr * 100);
                        }
                        return prev;
                    }, 0);
                    sums[index] = sums[index] / 100;
                } else {
                    sums[index] = ' ';
                }
            });
            return sums;
        },
        // 关闭子组件弹窗
        closeChildFn() {
            this.showContract = false;
        },
        // 查看详情
        lookMore(status) {
            // status 3:合同个数  4:预计方量  5:业务员销售合同数量统计   6:业务员销售预计方量统计
            this.alertStatus = status;
            this.showContract = true;
        },
        // 业务员销售合同数量统计
        contractNumberFn(data) {
            const myChart = this.$echarts.init(document.getElementById('contractNumber'));
            const option = {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross',
                        crossStyle: {
                            color: '#999',
                        },
                    },
                },
                grid: {
                    top: '13%',
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true,
                },
                xAxis: [
                    {
                        type: 'category',
                        data: this.htslSlotArr,
                        axisLabel: {
                            color: '#666666',
                            fontSize: 10,
                            interval: 0,
                        },
                        axisTick: {
                            show: false,
                        },
                        axisLine: {
                            lineStyle: {
                                color: '#D7D7D7',
                            },
                        },
                        splitLine: {
                            lineStyle: {
                                color: '#D7D7D7',
                                type: 'dashed',
                            },
                        },
                    },
                ],
                yAxis: [
                    {
                        type: 'value',
                        name: '单位(个)',
                        axisLabel: {
                            color: '#666666',
                            fontSize: 10,
                            interval: 0,
                        },
                        axisTick: {
                            show: false,
                        },
                        nameTextStyle: {
                            color: '#666666',
                            fontSize: 10,
                            padding: [10, 0, 0, 0],
                        },
                        axisLine: {
                            lineStyle: {
                                color: '#D7D7D7',
                                fontSize: 10,
                            },
                        },
                        splitLine: {
                            lineStyle: {
                                color: '#D7D7D7',
                                type: 'dashed',
                            },
                        },
                    },
                    {
                        type: 'value',
                        name: '单位(个)',
                        axisLabel: {
                            color: '#666666',
                            fontSize: 10,
                        },
                        nameTextStyle: {
                            color: '#666666',
                            fontSize: 10,
                        },
                        axisTick: {
                            show: false,
                        },
                        axisLine: {
                            lineStyle: {
                                color: '#D7D7D7',
                            },
                        },
                        splitLine: { show: false },
                    },
                ],
                series: {
                    type: 'bar',
                    data: data,
                    label: {
                        fontFamily: 'QuartzLTStd',
                        show: true,
                        position: 'top',
                        color: '#2E9BFC',
                        fontSize: '14',
                        padding: 5,
                    },
                    itemStyle: {
                        normal: {
                            color: new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                                offset: 0,
                                color: '#3E78C3', // 0% 处的颜色
                            }, {
                                offset: 1,
                                color: '#44A1F5', // 100% 处的颜色
                            }], false),
                        },
                    },
                },
            };
            myChart.setOption(option, true);
        },
        // 业务员销售预计方量统计
        contractEstimateFn(data) {
            const myChart = this.$echarts.init(document.getElementById('contractEstimate'));
            const option = {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross',
                        crossStyle: {
                            color: '#999',
                        },
                    },
                },
                grid: {
                    top: '13%',
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true,
                },
                xAxis: [
                    {
                        type: 'category',
                        data: this.yjflSlotArr,
                        axisLabel: {
                            color: '#666666',
                            fontSize: 10,
                            interval: 0,
                        },
                        axisTick: {
                            show: false,
                        },
                        axisLine: {
                            lineStyle: {
                                color: '#D7D7D7',
                            },
                        },
                        splitLine: {
                            lineStyle: {
                                color: '#D7D7D7',
                                type: 'dashed',
                            },
                        },
                    },
                ],
                yAxis: [
                    {
                        type: 'value',
                        name: '单位(方)',
                        axisLabel: {
                            color: '#666666',
                            fontSize: 10,
                        },
                        axisTick: {
                            show: false,
                        },
                        nameTextStyle: {
                            color: '#666666',
                            fontSize: 10,
                            padding: [10, 0, 0, 0],
                        },
                        axisLine: {
                            lineStyle: {
                                color: '#D7D7D7',
                                fontSize: 10,
                            },
                        },
                        splitLine: {
                            lineStyle: {
                                color: '#D7D7D7',
                                type: 'dashed',
                            },
                        },
                    },
                ],
                series: [
                    {
                        type: 'bar',
                        data: data,
                        label: {
                            fontFamily: 'QuartzLTStd',
                            show: true,
                            position: 'top',
                            color: '#FE9E1F',
                            fontSize: '14',
                            padding: 5,
                        },
                        itemStyle: {
                            normal: {
                                color: new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                                    offset: 0,
                                    color: '#EA8243', // 0% 处的颜色
                                }, {
                                    offset: 1,
                                    color: '#F0AF56', // 100% 处的颜色
                                }], false),
                            },
                        },
                    },
                ],
            };
            myChart.setOption(option, true);
        },
        // 按业务员
        bySalesman() {
            this.$axios
                .get('/interfaceApi/report/tjfx/xsht/months/salesman?date=&datenum=8')
                .then(res => {
                    this.tabListDataTwo = res;

                    this.tabListDataTwoList = res.list;
                    this.tabListDataTwoDate = res.date;
                    // 表格渲染
                    this.tabListDataTwoName = res.name.map(item => {
                        const arr = res.list.filter(key => {
                            return key.name === item;
                        });
                        return {
                            name: item,
                            list: arr,
                        };
                    });
                    this.$nextTick(() => {
                        this.$refs.salesTable.doLayout();
                    });
                    // 处理图表数据
                    this.tabListEchartsHtTwo = res.name;
                    this.htslSlotArr = res.name.splice(0, 8);
                    this.yjflSlotArr = res.yjxsflname.splice(0, 8);
                    // 合同
                    const htTotalData = this.htslSlotArr.map(item => {
                        const arr = res.list.filter(key => {
                            return key.name === item;
                        });
                        let total = 0;
                        arr.forEach(a => {
                            total = Math.round(total * 100 + a.htsl * 100) / 100;
                        });
                        return total;
                    });
                    // 预计销售方量合计
                    const flTotalData = this.yjflSlotArr.map(item => {
                        const arr = res.list.filter(key => {
                            return key.name === item;
                        });
                        let total = 0;
                        arr.forEach(a => {
                            total = Math.round(total * 100 + a.yjxsfl * 100) / 100;
                        });
                        return total;
                    });
                    setTimeout(() => {
                        // 业务员销售
                        this.contractNumberFn(htTotalData);
                        // 预计销售方量图表
                        this.contractEstimateFn(flTotalData);
                    }, 200);
                })
                .catch(error => {
                    this.$message.error(error.ErrorCode.Message);
                });
        },
    },
};

</script>
<style lang='stylus'>
.salesContractMonthBox
    overflow-y auto
    .month-data-analysis
        height 100%
        .table-list
            height calc(100% - 390px)
</style>
